import * as React from "react";
import { HelpBlock, ControlLabel, FormControl, FormGroup, InputGroup } from "react-bootstrap";
import styled from "styled-components";

import { validate } from "src/utils/validations";
import TextInputMetter from "src/presentations/elements/TextInputMetter";
import { Props } from "./types";

const StyledTextInput = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  width: 100%;
`;

const StyledLabel = styled(ControlLabel)`
  margin: 0;
  font-weight: 900;
  color: #333;
`;

const StyledFormControlWrapper = styled.div`
  margin-top: ${(props: { label?: string }) => (props.label ? "10px" : "0")};
  .input-group-addon {
    background-color: #fafafa;
  }

  .input-group-addon {
    border-top: 2px solid #ddd;
    border-bottom: 2px solid #ddd;
  }

  .input-group-addon:first-child {
    border-left: 2px solid #ddd;
  }

  .input-group-addon:last-child {
    border-right: 2px solid #ddd;
  }
`;

const StyledFormControl = styled(FormControl)`
  height: 40px;
  border: 2px solid #dfe3e9;
  border-radius: 2px;
  background-color: #ffffff;
  padding: 0 20px;
  box-shadow: none;
  &:focus {
    outline: none !important;
    box-shadow: none;
    border-color: #086ad8;
  }
  &.errorBorder {
    border: 2px solid #FE8F80;
  }
`

const StyledError = styled.p`
  color: #e44c4c;
`;

class TextInput extends React.PureComponent<Props> {
  handleChange: any = (event: React.FormEvent<HTMLInputElement>) => {
    let parsedValue: string | number = event.currentTarget.value;

    if (this.props.type === "number") {
      parsedValue = parseInt(event.currentTarget.value, 10) || 0;
    }

    this.props.onChange({
      name: event.currentTarget.name,
      value: parsedValue,
      error: validate(
        this.props.validators || [],
        event.currentTarget.value,
        this.props.values
      ).error,
    });
  };

  render() {
    const {
      id,
      help,
      values,
      onKeyPress,
      classNames = {},
      name,
      label,
      hideLabel,
      value,
      error = false,
      strenghPasswordControl = false,
      disabled = false,
      type = "text",
      placeholder = "",
      validators = [],
      textLeft,
      textRight,
      onKeyUp,
      autoComplete
    } = this.props;

    return (
      <StyledTextInput className={classNames.container}>
        {!hideLabel && label && (
          <StyledLabel className={classNames.label}>{label}</StyledLabel>
        )}
        <StyledFormControlWrapper>
          {textLeft || textRight ? (
            <FormGroup style={{ marginBottom: "0" }}>
              <InputGroup style={{ marginTop: "15px" }}>
                {textLeft && <InputGroup.Addon>{textLeft}</InputGroup.Addon>}
                <StyledFormControl
                  id={id}
                  required={true}
                  className={classNames.input}
                  type={type}
                  name={name}
                  value={value || (type === "number" ? 0 : "")}
                  disabled={disabled}
                  placeholder={placeholder}
                  onChange={this.handleChange}
                  onKeyPress={onKeyPress}
                  onKeyUp={onKeyUp}
                  label={label}
                  step={type === "number" ? "0.01" : undefined}
                  autoComplete={autoComplete}
                />
                {textRight && <InputGroup.Addon>{textRight}</InputGroup.Addon>}
              </InputGroup>
            </FormGroup>
          ) : (
            <StyledFormControl
              id={id}
              required={true}
              className={classNames.input}
              style={this.props.style || { marginTop: '15px' }}
              type={type}
              name={name}
              value={value || (type === "number" ? 0 : "")}
              disabled={disabled}
              placeholder={placeholder}
              onChange={this.handleChange}
              step={type === "number" ? "0.01" : undefined}
              onKeyPress={onKeyPress}
              onKeyUp={onKeyUp}
              label={label}
              autoComplete={autoComplete}
            />
          )}
        </StyledFormControlWrapper>
        {error && validate(validators, value, values).errorMessage && (
          <StyledError className={classNames.error}>
            {validate(validators, value, values).errorMessage}
          </StyledError>
        )}
        {help && <HelpBlock>{help}</HelpBlock>}
        {strenghPasswordControl ? (
          <TextInputMetter value={(value as string) || ""} />
        ) : null}
      </StyledTextInput>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/presentations/elements/TextInput/index.tsx